module.exports = __webpack_public_path__ + "img/008-monster.fc86e690.png";